import React, { useState } from 'react';
import { Subject } from '../../api/studykit';
import { FabButton, Menu, MenuItem, Typography } from '@dls/react-core';
import { ButtonProps } from '@material-ui/core';
import { Icon } from '@dls/react-icon';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { RemoveSubjectDialog } from '../dialogs/remove-subject-dialog';
import { usePermission } from '../../context/authorization';
import { DeleteDataConfirmDialog } from '../dialogs/delete-data-confirm-dialog';

interface SubjectMenuProps {
  subject: Subject;
  studyId: string;
  onSubjectRemoved: () => void;
}

export const SubjectMenu: React.FC<SubjectMenuProps> = ({ subject, studyId, onSubjectRemoved }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();
  const [removeSubjectDialog, setRemoveSubjectDialog] = useState(false);
  const [removeSubjectDataDialog, setRemoveSubjectDataDialog] = useState(false);
  const canDelete = usePermission('Subjects.Delete');
  const canDeleteData = usePermission('SubjectsData.Delete');

  const handleMenuClick: ButtonProps['onClick'] = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(undefined);
  };

  const actions = [
    {
      label: 'View',
      handleAction: (s: Subject) => {
        navigate(`/${RoutePaths.Studies}/${studyId}/subjects/${s.id}/details`);
      },
      disabled: false,
    },
    {
      label: 'Remove',
      handleAction: () => {
        setRemoveSubjectDialog(true);
      },
      disabled: !canDelete,
    },
    {
      label: 'Delete Data',
      handleAction: () => {
        setRemoveSubjectDataDialog(true);
      },
      disabled: !canDeleteData,
    },
  ];
  return (
    <>
      <FabButton
        onClick={handleMenuClick}
        size="small"
        variant="extended"
        dls_variant="quietEmphasis"
      >
        <Icon name={'ThreeDotsVertical'} size={'m'} />
      </FabButton>
      <Menu
        getContentAnchorEl={null}
        PaperProps={{
          className: 'DLSMenuList',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {actions.map((item) => (
          <MenuItem
            key={`${item.label}`}
            onClick={() => {
              item.handleAction(subject);
              handleMenuClose();
            }}
            disabled={item.disabled}
          >
            <Typography>{item.label}</Typography>
          </MenuItem>
        ))}
      </Menu>

      {canDelete && (
        <RemoveSubjectDialog
          subject={subject}
          studyId={studyId}
          open={removeSubjectDialog}
          onRemoved={onSubjectRemoved}
          onClose={() => {
            setRemoveSubjectDialog(false);
          }}
        />
      )}
      {canDeleteData && (
        <DeleteDataConfirmDialog
          subject={subject}
          open={removeSubjectDataDialog}
          onClose={() => {
            setRemoveSubjectDataDialog(false);
          }}
        />
      )}
    </>
  );
};
